"use client"

import { useState } from "react"
import { Routes, Route, useLocation } from "react-router-dom"
import Sidebar from "../common/Sidebar"
import Header from "../common/Header"
import Dashboard from "./Dashboard"
import DailyDevotions from "./DailyDevotions"
import Announcements from "./Announcements"
import Flyers from "./Flyers"
import VideoCategories from "./VideoCategories"
import ChurchProjects from "./ChurchProjects"
import PrayerRequests from "./PrayerRequests"
import Testimonies from "./Testimonies"
import InspirationalQuotes from "./InspirationalQuotes"
import UpcomingEvents from "./UpcomingEvents"
import LightSpotAccounts from "./LightSpotAccounts"
import MentorManagement from "./MentorManagement"
import Profile from "./Profile"
import Settings from "./Settings"
import "./AdminDashboard.css"

const AdminDashboard = ({ user, onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const location = useLocation()

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen)
  }

  const menuItems = [
    { path: "/admin", label: "Dashboard", icon: "dashboard" },
    { path: "/admin/devotions", label: "Daily Devotions", icon: "video_library" },
    { path: "/admin/announcements", label: "Announcements", icon: "campaign" },
    { path: "/admin/flyers", label: "Flyers", icon: "image" },
    { path: "/admin/videos", label: "Video Categories", icon: "movie" },
    { path: "/admin/projects", label: "Church Projects", icon: "architecture" },
    { path: "/admin/prayer-requests", label: "Prayer Requests", icon: "volunteer_activism" },
    { path: "/admin/testimonies", label: "Testimonies", icon: "record_voice_over" },
    { path: "/admin/quotes", label: "Inspirational Quotes", icon: "format_quote" },
    { path: "/admin/events", label: "Upcoming Events", icon: "event" },
    { path: "/admin/light-spot", label: "Light Spot Accounts", icon: "lightbulb" },
    { path: "/admin/mentors", label: "Mentor Management", icon: "people" },
  ]

  return (
    <div className={`admin-dashboard ${sidebarOpen ? "sidebar-open" : ""}`}>
      <Sidebar
        menuItems={menuItems}
        isOpen={sidebarOpen}
        toggleSidebar={toggleSidebar}
        currentPath={location.pathname}
        userRole="admin"
      />

      <div className="main-content">
        <Header
          title={menuItems.find((item) => item.path === location.pathname)?.label || "Dashboard"}
          user={user}
          onLogout={onLogout}
          toggleSidebar={toggleSidebar}
        />

        <div className="content-container">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/devotions" element={<DailyDevotions />} />
            <Route path="/announcements" element={<Announcements />} />
            <Route path="/flyers" element={<Flyers />} />
            <Route path="/videos" element={<VideoCategories />} />
            <Route path="/projects" element={<ChurchProjects />} />
            <Route path="/prayer-requests" element={<PrayerRequests />} />
            <Route path="/testimonies" element={<Testimonies />} />
            <Route path="/quotes" element={<InspirationalQuotes />} />
            <Route path="/events" element={<UpcomingEvents />} />
            <Route path="/light-spot" element={<LightSpotAccounts />} />
            <Route path="/mentors" element={<MentorManagement />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </div>
      </div>
    </div>
  )
}

export default AdminDashboard
